import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

export default function ProfileTab() {
    const { user, profile, refreshProfile } = useAuth();
    const [fullName, setFullName] = useState(profile?.full_name || '');
    const [phone, setPhone] = useState(profile?.phone || '');
    const [saving, setSaving] = useState(false);

    const save = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const { error } = await supabase.from('profiles').update({ full_name: fullName, phone }).eq('id', user.id);
            if (error) throw error;
            toast.success('Profile saved');
            refreshProfile();
        } catch (err) { toast.error(err.message); } finally { setSaving(false); }
    };

    return (
        <form onSubmit={save} className="max-w-xl bg-white border border-gray-200 rounded-xl p-6 space-y-4" data-testid="profile-form">
            <h2 className="text-lg font-bold text-aks-text">Your profile</h2>
            <div>
                <label className="text-[12px] font-medium">Email</label>
                <input value={user?.email || ''} disabled className="mt-1 w-full h-11 px-3 rounded-md border border-gray-200 bg-gray-50 text-[14px] text-gray-500" />
            </div>
            <div>
                <label className="text-[12px] font-medium">Full name</label>
                <input value={fullName} onChange={(e) => setFullName(e.target.value)} className="mt-1 w-full h-11 px-3 rounded-md border border-gray-300 text-[14px]" />
            </div>
            <div>
                <label className="text-[12px] font-medium">Phone</label>
                <input value={phone} onChange={(e) => setPhone(e.target.value)} className="mt-1 w-full h-11 px-3 rounded-md border border-gray-300 text-[14px]" />
            </div>
            <div>
                <label className="text-[12px] font-medium">Role</label>
                <div className="mt-2 ml-2 inline-block px-2 py-1 rounded bg-aks-navy text-white text-[11px] uppercase tracking-wider font-semibold">{profile?.role}</div>
            </div>
            <button disabled={saving} className="h-10 px-4 rounded-md bg-aks-gold text-aks-navy font-semibold text-[13px] disabled:opacity-60">{saving ? 'Saving…' : 'Save changes'}</button>
        </form>
    );
}
